var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstaReel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0076 20.9951L7.00764 21.0046C4.80764 21.0066 3.00614 19.2086 3.00364 17.0086L2.99564 8.50012L3.49914 8.00012L2.99414 7.00862C2.99214 4.94612 4.57264 3.23362 6.58264 3.02562C6.71664 3.01212 7.49914 3.50012 7.49914 3.50012L8.34914 3.00312L13.1091 2.99862L13.9991 3.50012L14.8491 2.99712L16.9901 2.99512C19.1901 2.99312 20.9916 4.79112 20.9941 6.99112L20.4991 7.50012L20.9956 8.50012L21.0036 16.9911C21.0061 19.1916 19.2076 20.9931 17.0076 20.9951Z",
    fill: "url(#paint0_radial_5665_3276)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5569V11.9429C9 11.1734 9.833 10.6919 10.4995 11.0769L14.4985 13.3839C15.1655 13.7689 15.1655 14.7314 14.4985 15.1164L10.4995 17.4234C9.833 17.8079 9 17.3264 9 16.5569Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9941 7.00012V8.50012H2.99414V7.01012C2.99414 7.00512 2.99414 7.00512 2.99414 7.00012H8.94414L6.61914 3.02012C6.73914 3.01012 6.86414 3.00512 6.98914 3.00512H8.34914L10.6791 7.00012H15.4441L13.1091 3.00012L14.8491 2.99512L17.1791 7.00012H20.9941Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5665_3276",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.50564 22.1736) scale(22.4495)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#FFCF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFA92B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#FF8A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#FF7325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#C837AB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaReel);
export default __webpack_public_path__ + "static/media/insta-reel.78ba1a8c7cbc85dc2ab897a8f8af31b9.svg";
export { ForwardRef as ReactComponent };